import React, { useState } from 'react';
import classNames from 'classnames';
import Transition from 'react-transition-group/Transition';
import styles from './Animator.module.scss';

function Animator({ children, in: inProp }) {
  const [node, setNode] = useState(null);

  const transitionNode = (node) => {
    setNode(node);
  };

  return (
    <Transition in={inProp} timeout={{ enter: 150, exit: 100 }}>
      {(state) => {
        const classes = classNames(styles.Animator, state && styles[state]);
        const height = node && state === 'exiting' ? node.getBoundingClientRect().height : 'auto';

        /* eslint-disable react/forbid-dom-props */
        return (
          <div className={classes} style={{ height }} ref={transitionNode}>
            {children}
          </div>
        );
        /* eslint-enable react/forbid-dom-props */
      }}
    </Transition>
  );
}

export default Animator;
